module.exports = __webpack_public_path__ + "img/indonesia.105d16b1.svg";